<div class="modal-header bg-light">
  <h4 class="modal-title" class="text-center">Exportación excel de movimientos</h4>
</div>
<div class="modal-body">
  <div class="row mb-2">
    <label> Seleccione el tipo de movimiento a exportar:</label>
  </div>
  <div class="row mb-2">
    <div class="col-auto">
      <label for="fechaDesde">Fecha desde:</label>
    </div>
    <div class="col">
      <div id="fechaDesde"> {{ fechaDesde }}</div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-auto">
      <label for="fechaHasta">Fecha hasta:</label>
    </div>
    <div class="col">
      <div id="fechaHasta"> {{ fechaHasta }}</div>
    </div>
  </div>
</div>
<div class="row mb-3">
  <div class="col d-flex justify-content-center">
    <button class="btn btn-primary" (click)="exportarRecargas()" [disabled]="exportandoRecargas || !enableExportRecarga">
      <span *ngIf="!exportandoRecargas">Recargas</span>
      <div *ngIf="exportandoRecargas" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Exportando recargas...</span>
      </div>
    </button>
    <button class="btn btn-primary ms-2" (click)="exportarRecepciones()" [disabled]="exportandoRecepciones || !enableExportRecepcion">
      <span *ngIf="!exportandoRecepciones">Recepciones</span>
      <div *ngIf="exportandoRecepciones" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Exportando recepciones...</span>
      </div>
    </button>
  </div>
</div>
<div class="modal-footer bg-light">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Volver clicked')">Volver</button>
</div>
